import { wencesApi } from "@/api/wencesApi";

/**
 * Guard: alta y edición requieren {modelName}.manage (gestión).
 */
export async function hasEditPermissionGuard(to, from, next) {
  try {
    // Si el usuario es admin, tiene acceso completo
    const role = localStorage.getItem("role");
    if (role === "admin") {
      return next();
    }

    // Obtener el nombre del modelo de los parámetros de la ruta
    const modelName = to.params.modelName;
    if (!modelName) {
      return next("/dashboard");
    }

    // Obtener los permisos del usuario
    const response = await wencesApi.get("/api/users/myprofile");
    if (!response.data.ok) {
      return next("/dashboard");
    }

    const userData = response.data.data;
    let roleId;
    if (typeof userData.role === "string") {
      roleId = userData.role;
    } else if (userData.role && userData.role._id) {
      roleId = userData.role._id;
    }

    if (!roleId) {
      return next("/dashboard");
    }

    // Obtener los permisos del rol
    const roleResponse = await wencesApi.get(`/api/roles/${roleId}`);
    if (
      !roleResponse.data.success ||
      !roleResponse.data.data ||
      !roleResponse.data.data.permissions
    ) {
      return next("/dashboard");
    }

    const permissions = roleResponse.data.data.permissions;
    const modelNameLower = modelName.toLowerCase();
    const requiredPermission = `${modelNameLower}.manage`;

    const hasPermission = permissions.some((perm) => {
      const permLower = perm.toLowerCase();
      return (
        permLower === requiredPermission ||
        permLower === "all_access" ||
        permLower === `${modelNameLower}_manage` ||
        permLower === `${modelNameLower} - manage`
      );
    });

    if (hasPermission) {
      next();
    } else {
      // Redirigir a la vista de detalle en lugar de edición
      const itemId = to.params.itemId;
      if (itemId) {
        next({
          name: "DynamicModelDetail",
          params: { modelName: modelName, itemId: itemId },
        });
      } else {
        next({
          name: "DynamicModel",
          params: { modelName: modelName },
        });
      }
    }
  } catch (error) {
    console.error("Error verificando permisos de edición:", error);
    // En caso de error, redirigir al dashboard
    next("/dashboard");
  }
}

export default hasEditPermissionGuard;

